// src/components/Loader.js
import React from 'react';
import './Loader.css'; // Add styling for the loader

const Loader = () => {
  return (
    <div className="loader loader-height">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
